import BaseStore from './base-store.js'
import {API2_TENANTS} from 'consts/api2.js'

export class Tenant extends BaseStore {
  constructor(values = {}) {
    super({
      id: undefined,
      name: undefined,
      email_domain: undefined,
      shared_company_id: undefined,
      ...values
    })
    this.api_stats = `${API2_TENANTS}/${this.id}/stats`
  }

  async doSave(rest, changed) {
    const to_write = {}
    for (const key of changed) to_write[key] = this._state[key]
    const {bleach} = await rest.patch(`${API2_TENANTS}/${this.id}`, to_write)
    this._bleach(bleach)
  }
}

class TenantsStore extends BaseStore {
  constructor() {
    super({
      view_items: [],
      view_total: 0,
      total: 0,
      caps: {},
    })
  }

  async doLoad(rest, params = {}) {
    const data = await (rest || this._rest).get(API2_TENANTS, {...params})
    this._state.view_items = data.view_items.map(t => new Tenant(t))
    this._state.view_total = data.view_total
    this._state.total = data.total
  }

  getTenant(id) {
    return this._state.view_items.find(x => x.id === id)
  }

  async loadTenant(id) {
    const data = await this._rest.get(`${API2_TENANTS}/${id}`)
    return new Tenant(data)
  }

  async loadCaps() {
    this._state.caps = await this._rest.get(`${API2_TENANTS}/caps`)
    return this._state.caps
  }

  async newTenant(fields) {
    const data = await this._rest.post(API2_TENANTS, fields)
    return new Tenant(data)
  }
}

const tenants = new TenantsStore()
export default tenants
